/* src/app/register/register.component.css */
.screenPos {
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .screenPos {
    margin-top: -25%;
  }
}
.cardPos {
  width: 100rem;
  margin-bottom: 10%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .cardPos {
    width: 100rem;
    margin-top: 5rem;
  }
}
.theSpace {
  margin-bottom: 30px;
}
.mobilePos {
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .mobilePos {
    margin-top: 42rem;
    padding-top: 10px;
    margin-bottom: 2rem;
  }
}
.hero__play {
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(94, 206, 66, 0.8);
  width: 9.4rem;
  height: 9.4rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 7rem;
  margin-top: 2rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .hero__play {
    top: 11.8rem;
    margin-top: -3rem;
    transform: translateX(-50%);
    width: 6rem;
    height: 6rem;
  }
}
.hero__play img {
  max-width: 1rem;
}
.modalSize {
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .modalSize {
  }
}
.link {
  color: #0000FF;
}
::ng-deep .popover-body {
  font-size: small;
}
::ng-deep #register:hover {
  color: white !important;
}
.hero {
  background-color: #2C3B51;
  position: relative;
  color: #fff;
  padding-top: 19%;
  padding-bottom: 30.3rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .hero {
    padding-top: 96%;
    padding-bottom: 11.3rem;
  }
}
.hero .hero__media {
  max-width: 102.5rem;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
@media (max-width: 1023px) {
  .hero .hero__media {
    max-width: 50%;
  }
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .hero .hero__media {
    max-width: 100%;
    height: 100%;
  }
}
.hero .hero__image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  z-index: -1;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .hero .hero__image {
    background-position: left;
  }
}
.hero .hero__play {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background-color: rgba(94, 206, 66, 0.8);
  width: 9.4rem;
  height: 9.4rem;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .hero .hero__play {
    top: 11.8rem;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 6rem;
    height: 6rem;
  }
  .hero .hero__play img {
    max-width: 1rem;
  }
}
.hero .hero__content {
  color: #fff;
  max-width: 39.2rem;
  margin-left: auto;
  z-index: 2;
  position: relative;
  padding: 27% 0 0%;
  margin-top: -45rem;
}
@media screen and (max-width: 1680px) {
  .hero .hero__content {
    margin-top: -45rem;
  }
}
@media screen and (max-width: 1600px) {
  .hero .hero__content {
    margin-top: -45rem;
  }
}
@media screen and (max-width: 1440px) {
  .hero .hero__content {
    margin-top: -45rem;
  }
}
@media screen and (max-width: 1400px) {
  .hero .hero__content {
    margin-top: -45rem;
  }
}
@media screen and (max-width: 1366px) {
  .hero .hero__content {
    margin-top: -48rem;
  }
}
@media screen and (max-width: 1360px) {
  .hero .hero__content {
    margin-top: -49rem;
  }
}
@media screen and (max-width: 1280px) {
  .hero .hero__content {
    margin-top: -45rem;
  }
}
@media screen and (max-width: 1152px) {
  .hero .hero__content {
    margin-top: -45rem;
  }
}
@media screen and (max-width: 1024px) {
  .hero .hero__content {
    margin-top: -45rem;
  }
}
@media (max-width: 767px) {
  .hero .hero__content {
    max-width: 50%;
    padding: 5rem 0 5rem 1.5rem;
    margin-top: -31rem;
    color: black;
    font-weight: bold;
  }
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .hero .hero__content {
    max-width: 100%;
    padding: 0 2.2rem 2rem;
  }
}
.hero .hero__content h3 {
  font-size: 3rem;
  line-height: 1.2;
  margin-bottom: 3.8rem;
}
@media (max-width: 1023px) {
  .hero .hero__content h3 {
    font-size: 2.6rem;
    margin-bottom: 2rem;
  }
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .hero .hero__content h3 {
    font-size: 2.4rem;
    margin-bottom: 1.4rem;
  }
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .hero .hero__content .btn {
    min-width: 100%;
    min-height: 5.5rem;
    line-height: 5.1rem;
  }
}
.hero .hero__content ul {
  list-style: none;
  margin-bottom: 3.4rem;
}
@media (max-width: 1023px) {
  .hero .hero__content ul {
    margin-bottom: 2rem;
  }
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .hero .hero__content ul {
    margin-bottom: 1.3rem;
  }
}
.hero .hero__content ul li + li {
  margin-top: 1.3rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .hero .hero__content ul li + li {
    margin-top: 0.7rem;
  }
}
.hero .hero__content ul li {
  position: relative;
  font-size: 1.8rem;
  line-height: 1.78;
  padding-left: 4.1rem;
}
@media (max-width: 1023px) {
  .hero .hero__content ul li {
    font-size: 1.6rem;
    padding-left: 3rem;
  }
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .hero .hero__content ul li {
    padding-left: 30px;
  }
}
.hero .hero__content ul li img {
  position: absolute;
  top: 50%;
  left: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .hero .hero__content ul li img {
    max-width: 1.8rem;
  }
}
.shell {
  max-width: calc(118rem + 1.5rem * 2);
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1rem;
  margin: auto;
  width: 100%;
}
.shell--size-1 {
  max-width: 120rem;
}
.shell--size-2 {
  max-width: 100rem;
}
.shell--size-3 {
  max-width: 105rem;
}
.shell--size-4 {
  max-width: 83rem;
}
.shell--size-5 {
  max-width: 108rem;
}
.shell--size-6 {
  max-width: 103rem;
}
.shell--size-7 {
  max-width: 95rem;
}
.shell--size-8 {
  max-width: 123rem;
}
.shell--fluid {
  max-width: none;
}
::ng-deep .heroImg {
  background-image: url("./media/hero-img.png") !important;
}
.row {
  margin-top: 8%;
  font-size: large;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .row {
    margin-top: 1%;
    font-size: large;
  }
}
.btnE {
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: #5ECE42;
  border-radius: 10px;
  font-weight: 700;
  color: #fff;
  border: 0.2rem solid #5ECE42;
  min-width: 23.6rem;
  padding: 0 1rem;
  -webkit-transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  -o-transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  transition:
    background-color 0.4s,
    border-color 0.4s,
    color 0.4s;
  min-height: 6rem;
  line-height: 5.6rem;
  font-size: 1.8rem;
}
.btnE:hover {
  background-color: #fff;
  color: #5ECE42;
}
.joinUsBtn {
  border-radius: 10px !important;
  font-size: medium !important;
  background-color: #5ECE42 !important;
  color: white !important;
}
/*# sourceMappingURL=register.component.css.map */
